import { render, staticRenderFns } from "./payChart.vue?vue&type=template&id=0967da6c&scoped=true&"
import script from "./payChart.vue?vue&type=script&lang=js&"
export * from "./payChart.vue?vue&type=script&lang=js&"
import style0 from "./payChart.vue?vue&type=style&index=0&id=0967da6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967da6c",
  null
  
)

export default component.exports